export default __webpack_public_path__ + "static/media/3.184b9552.png";